export const locale = {
    lang: 'fr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'SAMPLE'        : {
                'TITLE': 'Exemple',
                'BADGE': '15'
            }
        }
    }
};



// WEBPACK FOOTER //
// /usr/app/src/app/navigation/i18n/fr.ts